import actionTypes from '../actions/reduxActions/actionTypes';

const initialState = {
    isLoading: false,
    items: [],
};

const flowLibrary = (state = initialState, { type, payload, error, meta }) => {

    switch (type) {

    case actionTypes.FLOW_LIBRARY_LOADING:

        return {
            ...state,
            isLoading: true,
        };

    case actionTypes.FLOW_LIBRARY_SET:

        return {
            isLoading: false,
            items: payload,
        };

    default:
        return state;
    }
};

export default flowLibrary;
